import { ButtonContent, StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, outlined, children, onClick }: ButtonProps) => (
  <StyledButton color={color} outlined={outlined} onClick={onClick}>
    <ButtonContent>
      {children}
    </ButtonContent>
  </StyledButton>
);
